import React from 'react'
import './index.scss'
import Header from '@/components/header'
import { NavLink, Switch, Route, Redirect } from 'react-router-dom'
// import { DayEarn, MonthEarn } from '@/views'
import DayEarn from '@/views/dayearn'
import MonthEarn from '@/views/monthearn'
import {getLocationSearch} from '@/utils/utils'
const DmEarn = () => {
  return (
    <div className="dmearn__box">
      <Header tit="">
        <div className="navlink__box">
          <NavLink 
            className={`${getLocationSearch().tenantTag ? getLocationSearch().tenantTag: 'alink'}`} 
            activeClassName = {`${getLocationSearch().tenantTag ? getLocationSearch().tenantTag + 'active': 'active'}`}
            to="/dmearn/todayearn">日流水</NavLink>
          <NavLink 
            className={`${getLocationSearch().tenantTag ?getLocationSearch().tenantTag: 'alink'}`} 
            activeClassName = {`${getLocationSearch().tenantTag ? getLocationSearch().tenantTag + 'active': 'active'}`}
            to="/dmearn/monthearn">月流水</NavLink>
        </div>
      </Header>

        <Switch>
          <Redirect from="/dmearn" to="/dmearn/todayearn" exact />
          <Route exact path="/dmearn/todayearn" render={() => <DayEarn />} />
          <Route exact path="/dmearn/monthearn" render={() => <MonthEarn />} />
        </Switch>
    </div>
  )
}
export default DmEarn
